<script>
import { mapActions } from 'vuex';
import commonDeleteDialogComponent from '../common-delete-dialog.vue';

export default {
    extends: commonDeleteDialogComponent,

    computed: {
        btnDeleteId() {
            return 'deleteFreeGift';
        },

        labels() {
            return {
                deleteBtnText: 'actions.delete',
                deleteHeading: 'dialogs.deleteFreeGift.header',
            };
        },
    },

    methods: {
        ...mapActions('freeGifts', ['deleteFreeGift']),

        async deleteSelectedItem() {
            await this.deleteFreeGift({ id: this.resourceId });
            this.closeAll();
        },
    },
};
</script>
